import React from 'react';
import { Box, TextField, Button, Link, CircularProgress } from '@mui/material';
import { PRIMARYCOLOR } from '../../Constants';

function LoginForm({ email, password, setEmail, setPassword, handleLogin, handleModalOpen, loading }){
	return(
		<Box component="form" onSubmit={handleLogin}>
			<TextField
	            sx={{ width: '100%' }}
	            required
	            label="Email"
	            variant="standard"
	            value={email}
	            disabled={loading}
	            autoComplete="email"
	            onChange={(e) => setEmail(e.target.value)}
	          />

	            <TextField
	              sx={{ width: '100%', marginTop: '15px' }}
	              required
	              label="Password"
	              type="password"
	              variant="standard"
	              value={password}
	              disabled={loading}
	              autoComplete="current-password"
	              onChange={(e) => setPassword(e.target.value)}
	            />
	         
	          <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
	            <Button
	              sx={{ backgroundColor: PRIMARYCOLOR, minWidth: 92 }}
	              variant="contained"
	              type="submit"
	              disabled={loading}
	            >
	              {loading ? <CircularProgress size={20} color="inherit" /> : 'Login'}
	            </Button>

	            <Link
	              component="button"
	              type="button"
	              sx={{ marginLeft: 'auto', color: PRIMARYCOLOR }}
	              underline="none"
	              onClick={handleModalOpen}
	              disabled={loading}
	            >
	                Forgot Password
	            </Link>

	        </Box>
        </Box>
	)
}

export default LoginForm
